export default __webpack_public_path__ + "static/media/logoAux.f06abd1b.png";